import { render, staticRenderFns } from "./HandOverRequests.vue?vue&type=template&id=7210b93c&scoped=true"
import script from "./HandOverRequests.vue?vue&type=script&lang=js"
export * from "./HandOverRequests.vue?vue&type=script&lang=js"
import style0 from "./HandOverRequests.vue?vue&type=style&index=0&id=7210b93c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7210b93c",
  null
  
)

export default component.exports